import styled from "styled-components";
import useReportView from "features/homework/hooks/useReportView";
import WordView from "./WordView";
import SentenceView from "./SentenceView";
import VideoView from "./VideoView";
import SettingView from "./SettingView";
import WordTableViewer from "./WordTableViewer";
import SentenceTableViewer from "./SentenceTableViewer";
import VideoTableViewer from "./VideoTableViewer";
import { hw } from "../homeworkUi";

interface ReportViewProps{
    nowFolder:string,
    selectedReport:string,
    viewer?:boolean
}

const ReportView = ({nowFolder, selectedReport, viewer}:ReportViewProps) => {
    const {navItem, selectedReportType, onReportTypeClickHandler,
        path, wordList, setWordList, sentenceList, setSentenceList, videoList, setVideoList,
        onRegisterAllReportClickHandler, setting, setSetting,
        isRegisterSucceed, onRegisterSucceedModalConfirmHandler,
        isRegisterFailed, onRegisterFaildModalConfirmHandler
    } = useReportView(selectedReport, nowFolder, viewer);

    const viewNav = () => {
        return navItem.map(item => {
            return (
                <NavItem
                    key={item.id}
                    type="button"
                    $active={selectedReportType === item.id}
                    onClick={() => onReportTypeClickHandler(item.id)}
                >
                    {item.name}
                </NavItem>
            )
        })
    }

    const parseBoolean = (num:number) => {
        if(num){
            return true
        }
        return false;
    }

    const viewContentView = () => {
        let content_view = null;
        switch(selectedReportType){
            case 1:
                content_view = viewer ? <WordTableViewer list={wordList} /> : <WordView list={wordList} setList={setWordList} path={path}/>
                break;
            case 2:
                content_view = viewer ? <SentenceTableViewer list={sentenceList}/> : <SentenceView list={sentenceList} setList={setSentenceList} path={path}/>
                break;
            case 3:
                content_view = viewer ? <VideoTableViewer list={videoList}/> : <VideoView list={videoList} setList={setVideoList} path={path}/>
                break;
            case 4:
                content_view = <SettingView viewer={viewer} setting={setting} setSetting={setSetting} path={path} hasWordReport={parseBoolean(wordList.length)} hasSentenceReport={parseBoolean(sentenceList.length)} hasVideoReport={parseBoolean(videoList.length)} 
                onRegisterAllClickHandler={onRegisterAllReportClickHandler} isRegisterSucceed={isRegisterSucceed} onRegisterSucceedModalConfirmHandler={onRegisterSucceedModalConfirmHandler}
                isRegisterFailed={isRegisterFailed} onRegisterFaildModalConfirmHandler={onRegisterFaildModalConfirmHandler}/>
                break;
            default:
                return;
        }
        return content_view;
    }

    if(!selectedReport){
        return (
            <EmptyState>
                <EmptyTitle>과제를 선택하세요</EmptyTitle>
                <EmptyText>
                    {viewer
                        ? "왼쪽 목록에서 폴더를 열고 과제를 클릭하면 내용이 표시됩니다."
                        : "왼쪽에서 폴더를 열고 과제를 고르거나, 왼쪽 메뉴의 과제 추가로 새 과제를 만드세요."}
                </EmptyText>
            </EmptyState>
        )
    }

    return(
        <Container>
            <Navigation>
                {viewNav()}
            </Navigation>
            <Content>
                {viewContentView()}
            </Content>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-height: 0;
    background: ${hw.bg};
`;

const Navigation = styled.div`
    background: ${hw.surface};
    width: 100%;
    display: flex;
    gap: 4px;
    padding: 0 16px;
    border-bottom: 1px solid ${hw.border};
    flex-shrink: 0;
`;

const NavItem = styled.button<{ $active: boolean }>`
    appearance: none;
    border: none;
    background: transparent;
    color: ${props => props.$active ? hw.brand : hw.textMuted};
    font-size: 15px;
    font-weight: 600;
    padding: 14px 18px;
    cursor: pointer;
    position: relative;
    letter-spacing: -0.02em;

    &::after {
        content: "";
        position: absolute;
        left: 12px;
        right: 12px;
        bottom: 0;
        height: 2px;
        border-radius: 2px;
        background: ${props => props.$active ? hw.brand : "transparent"};
    }

    &:hover {
        color: ${props => props.$active ? hw.brand : hw.text};
        background: ${hw.bg};
    }
`;

const Content = styled.div`
    display: flex;
    flex-grow: 1;
    min-height: 0;
    overflow: hidden;
`;

const EmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex: 1;
    min-height: 280px;
    color: ${hw.textMuted};
`;

const EmptyTitle = styled.div`
    font-size: 18px;
    font-weight: 700;
    color: ${hw.text};
`;

const EmptyText = styled.div`
    font-size: 14px;
    color: ${hw.textMuted};
`;

export default ReportView;
